import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { UpdateSpocNameAndSettingsRPC } from "./updateSpocNameAndSettingsRPC";

export class UpdateSpocNameAndSettingsRPCClientImpl extends UpdateSpocNameAndSettingsRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: UpdateSpocNameAndSettingsRPC.Request): Promise<LeoRPCResult<UpdateSpocNameAndSettingsRPC.Response, UpdateSpocNameAndSettingsRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/UpdateSpocNameAndSettings",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      UpdateSpocNameAndSettingsRPC.ResponseDTO,
      UpdateSpocNameAndSettingsRPC.Errors.ErrorsDTO,
      UpdateSpocNameAndSettingsRPC.Response,
      UpdateSpocNameAndSettingsRPC.Errors.Errors
    >(
      response,
      "spoc-management/UpdateSpocNameAndSettings",
      UpdateSpocNameAndSettingsRPC.Response.fromDTO,
      UpdateSpocNameAndSettingsRPC.Errors.fromDTO
    );
  }
}
